module.exports = __webpack_public_path__ + "assets/images/extra_man1.38037472f6f7d037677c3275370d10e9.svg";